import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { isConditionMet } from 'features/dynamicForm/utils/conditionHelper';

export function useIsRequired(field) {
    const { getValues, clearErrors } = useFormContext();

    const isRequired = field.required || field.requiredConditions?.some((condition) => isConditionMet(getValues, condition));

    useEffect(() => {
        clearErrors(field.key);
    }, [clearErrors, field.key, isRequired]);

    return isRequired;
}
